import React, { useState } from "react";
import coin from  "../../assets/images/withdraw/coin.svg";
import item1 from  "../../assets/images/withdraw/item1.png";
import item2 from  "../../assets/images/withdraw/item2.png";
import item3 from  "../../assets/images/withdraw/item3.png";
import item4 from  "../../assets/images/withdraw/item4.png";
import item5 from  "../../assets/images/withdraw/item5.png";
import item6 from  "../../assets/images/withdraw/item6.png";
import progress from  "../../assets/images/withdraw/float.svg";
import closeicon from  "../../assets/images/withdraw/close.svg";
import { Button } from "react-bootstrap";
const WithdrawItems = () => {

  const item = 6;

  const [show, setShow] = useState(false);

  const handleSelect = () => {
    setShow(!show)
  }

  return (
  <div className={`withdraw-items-grid ${show ? `grid-expand` : ``}`} >

    
      <div className="items-grid">
      {[...Array(item)].map((index) => (
          <>
          <div className="items-box" key={index} onClick={handleSelect}>
            <div className="items-category">Factory New</div>
            <div className="items-img">
              <img src={item1} alt="" />
            </div>
            <div className="item-progress">
             <img src={progress} alt="" />
            </div>
            <div className="items-info">
              <span>Contraband Rifle</span>
              <h4>StatTrak™ M4A4 | Howl</h4>
            </div>
            <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
                <p>Suggested Price $231.42</p>
            </div>
          </div>

          <div className="items-box" onClick={handleSelect}>
            <div className="items-category">Factory New</div>
            <div className="items-img">
              <img src={item2} alt="" />
            </div>
            <div className="item-progress">
             <img src={progress} alt="" />
            </div>
            <div className="items-info">
              <span>Contraband Rifle</span>
              <h4>StatTrak™ M4A4 | Howl</h4>
            </div>
            <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
                <p>Suggested Price $231.42</p>
            </div>
          </div>

          <div className="items-box" onClick={handleSelect}>
            <div className="items-category">Factory New</div>
            <div className="items-img">
              <img src={item3} alt="" />
            </div>
            <div className="item-progress">
             <img src={progress} alt="" />
            </div>
            <div className="items-info">
              <span>Contraband Rifle</span>
              <h4>StatTrak™ M4A4 | Howl</h4>
            </div>
            <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
                <p>Suggested Price $231.42</p>
            </div>
          </div>

          <div className="items-box" onClick={handleSelect}>
            <div className="items-category">Factory New</div>
            <div className="items-img">
              <img src={item4} alt="" />
            </div>
            <div className="item-progress">
             <img src={progress} alt="" />
            </div>
            <div className="items-info">
              <span>Contraband Rifle</span>
              <h4>StatTrak™ M4A4 | Howl</h4>
            </div>
            <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
                <p>Suggested Price $231.42</p>
            </div>
          </div>

          <div className="items-box" onClick={handleSelect}>
            <div className="items-category">Factory New</div>
            <div className="items-img">
              <img src={item5} alt="" />
            </div>
            <div className="item-progress">
             <img src={progress} alt="" />
            </div>
            <div className="items-info">
              <span>Contraband Rifle</span>
              <h4>StatTrak™ M4A4 | Howl</h4>
            </div>
            <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
                <p>Suggested Price $231.42</p>
            </div>
          </div>

          <div className="items-box" onClick={handleSelect}>
            <div className="items-category">Factory New</div>
            <div className="items-img">
              <img src={item6} alt="" />
            </div>
            <div className="item-progress">
             <img src={progress} alt="" />
            </div>
            <div className="items-info">
              <span>Contraband Rifle</span>
              <h4>StatTrak™ M4A4 | Howl</h4>
            </div>
            <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
                <p>Suggested Price $231.42</p>
            </div>
          </div>

          </>
         ))}
      </div>


      <div className={`select-item ${show ? `show` : ``}`}>

        <div className="select-item-heading">
          <h5>Selected Item</h5>
          <div className="close-item">
              <span>Deselect</span>
              <span onClick={handleSelect}><img src={closeicon} alt="" /></span>
          </div>
        </div>

        <div className="selected-item-grid">

          <div className="selected-item-box">
            <div className="selected-item-cover">
                <img src={item1} alt="" />
            </div>
            <div className="selected-item-info">
              <div className="items-info">
                <span>Contraband Rifle</span>
                <h4>StatTrak™ M4A4 | Howl</h4>
              </div>
              <div className="items-category">Factory New</div>
              <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
              </div>
            </div>
          </div>

          <div className="selected-item-box">
            <div className="selected-item-cover">
                <img src={item2} alt="" />
            </div>
            <div className="selected-item-info">
              <div className="items-info">
                <span>Contraband Rifle</span>
                <h4>StatTrak™ M4A4 | Howl</h4>
              </div>
              <div className="items-category">Factory New</div>
              <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
              </div>
            </div>
          </div>


          <div className="selected-item-box">
            <div className="selected-item-cover">
                <img src={item3} alt="" />
            </div>
            <div className="selected-item-info">
              <div className="items-info">
                <span>Contraband Rifle</span>
                <h4>StatTrak™ M4A4 | Howl</h4>
              </div>
              <div className="items-category">Factory New</div>
              <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
              </div>
            </div>
          </div>



        </div>


        <div className="selected-item-footer">

          <div className="spend">
              <span>You will spend </span>
              <span><img src={coin} alt="" /> 245.91</span>
          </div>

          <Button>Withdraw 3 Items</Button>

        </div>

      </div>




  </div>
  );
};

export default WithdrawItems;
